$(function () {
    //使用皮肤标识ucplogin/prelogin
    var domainInfo = getLocalStorage("domainInfo");
    var vc2Interfacename = domainInfo.vc2Interfacename;
    var vc2Logo = domainInfo.vc2Logo;
    var imgpath = domainInfo.vc2Background;
    var vcxTrademark = domainInfo.vcxTrademark;
    var vc2BodyLogo = domainInfo.vc2BodyLogo;
    var vc2TabLogo = domainInfo.vc2TabLogo;
    if (domainInfo.vc2DomFlag == 'ucplogin') {
        if (hasValue(vc2BodyLogo)) {
            $("#logo").attr('src', vc2BodyLogo).css("width", "30px").css("height", "30px")
        }
        $("#favicon").attr("href", vc2TabLogo)
        $("#id-text").text(vc2Interfacename);
        $("#id-company-text").text(vcxTrademark);
        $(".blur-login").css("background-image", "url(" + imgpath + ")").css(" background-repeat", "no-repeat").css("background-color", "#394557").css('background-size', '100% 100%');
    } else {
        $("#favicon").attr("href", vc2TabLogo)
        $("#id-text").text(vc2Interfacename);
        if (hasValue(imgpath)) {
            $("#backdropImg").append("<img src='" + imgpath + "'>")
        }
    }

    setLocalStorage('IsLocalReady', false);

    function isLocalStorageSupported() {
        var testKey = 'test',
            storage = window.sessionStorage;
        try {
            storage.setItem(testKey, 'testValue');
            storage.removeItem(testKey);
            return true;
        } catch (error) {
            return false;
        }
    }

    if (!isLocalStorageSupported()) {
        alert("您处于无痕浏览模式或当前设备不支持localStorage/sessionStorage，系统无法正常使用");
        return false
    }

    // 如果是通过iframe 加载本页面 设置token到cookie
    if (hasValue(getQueryParam('token'))) {
        setToken(getQueryParam('token'), true);
        localStorage.setItem('appId', "1");
    }

    // 设置默认行为
    $('#vc2Username').focus();
    $(document).keyup(function (event) {
        if (event.keyCode == 13) {
            login()
        }
    });
    $('#login').click(function () {
        login()
    })


    function setToken(token, isIframe) {
        //如果不是在iframe中的嵌套，则登陆之前先将cookie中的token删掉
        if (!hasValue(isIframe)) {
            $.removeCookie('token', {domain: window.location.hostname, path: '/'});
        }
        $.cookie('token', token, {
            expires: 7,
            path: '/'
        });
        localStorage.setItem('right_token', token);
        sessionStorage.setItem('originalToken', token);
        sessionStorage.setItem('loginToken', token);
    }

    function setSessionUser(sessionUser) {
        localStorage.setItem('sessionUser', JSON.stringify(sessionUser));
    }

    function login() {
        var vc2Username = $('#vc2Username').val();
        var vc2Userpwd = $('#vc2Userpwd').val();
        var verifyCode = $("#verifyCode").val();
        var loginAgainFlag = 0
        if (vc2Username == "") {
            $('.errortip').html('用户名不能为空');
            return false;
        } else if (vc2Userpwd == "") {
            $('.errortip').html('密码不能为空');
            return false;
        } else if (verifyCode == "") {
            $('.errortip').html('验证码不能为空');
            return false;
        } else {
            $('#loading').show();
            ajaxLogin(vc2Username, vc2Userpwd, loginAgainFlag, verifyCode)
        }
    }

    function isUCP() {
        var domainInfo = getLocalStorage("domainInfo");
        var isUCP = false;
        if (!!domainInfo) {
            if (domainInfo.vc2DomFlag == 'ucplogin') {
                isUCP = true;
            }
        } else {
            isUCP = true;
        }
        return isUCP;
    }

    function ajaxLogin(vc2Username, vc2Userpwd, loginAgainFlag, verifyCode) {
        let envParam = window.localStorage.getItem("envParam");
        var version = (hasValue(envParam) && hasValue(JSON.parse(envParam).ENV)) ? JSON.parse(envParam).ENV : 1.0;
        var params = {};
        params.username = vc2Username;
        params.userpwd = vc2Userpwd;
        params.loginAgainFlag = loginAgainFlag;
        params.systemFlag = 0;
        params.uuId = $("#verifyUuid").val();
        params.verifyCode = verifyCode;
        $.ajax({
            url: setDomain("manage", "sso/loginByVerifyCode.do"),
            type: "post",
            timeout: 3000,
            async: false,
            dataType: "json",
            data: params,
            success: function (data) {
                if (data.success) {
                    remember();
                    setToken(data.responseBody.token);
                    setSessionUser(data.responseBody.sessionUser);
                    getQuoteCityCode();
                    localStorage.setItem('appId', "1");
                    sessionStorage.setItem('roleid', data.responseBody.sessionUser.roleId);
                    if (isUCP()) {
                        localStorage.setItem('aliyunInstanceId', data.responseBody.aliyunInstanceId);
                        localStorage.setItem("callcenterUserConfig", data.responseBody.callcenterUserConfig);
                    }
                    if (data.responseBody.nearExpiration && data.responseBody.nearExpiration == 1) {
                        alertfuncV2("提醒", "帐号即将到期，请及时联系管理员！", function () {
                            location.href = "/public_build/views/index.html#page/main?version=" + version;
                        });
                        return false;
                    }
                    if (isUCP()) {
                        location.href = "/public_build/views/index.html#page/main?version=" + version;
                    } else {
                        location.href = "/public_build/views/preIndex.html#page/main?version=" + version;
                    }
                } else {
                    if (hasValue(data.responseBody) && data.responseBody.code == "10001" && hasValue(data.responseBody)) {
                        confirmV2("提示信息", data.msg, function (v) {
                            if (v) {
                                var params = {};
                                params.username = vc2Username;
                                params.userpwd = vc2Userpwd;
                                params.loginAgainFlag = 1;
                                params.systemFlag = 0;
                                params.loginSource = "ucp";
                                params.uuId = $("#verifyUuid").val();
                                params.verifyCode = $("#verifyCode").val();
                                $.ajax({
                                    url: setDomain("manage", "sso/loginByVerifyCode.do"),
                                    type: "post",
                                    timeout: 3000,
                                    async: false,
                                    dataType: "json",
                                    data: params,
                                    success: function (data) {
                                        if (data.success) {
                                            remember();
                                            setToken(data.responseBody.token);
                                            setSessionUser(data.responseBody.sessionUser);
                                            getQuoteCityCode();
                                            localStorage.setItem('appId', "1");
                                            sessionStorage.setItem('roleid', data.responseBody.sessionUser.roleId);
                                            if (isUCP()) {
                                                localStorage.setItem('aliyunInstanceId', data.responseBody.aliyunInstanceId);
                                                localStorage.setItem("callcenterUserConfig", data.responseBody.callcenterUserConfig);
                                            }
                                            if (data.responseBody.nearExpiration && data.responseBody.nearExpiration == 1) {
                                                alertfuncV2("提醒", "帐号即将到期，请及时联系管理员！", function () {
                                                    location.href = "/public_build/views/index.html#page/main?version=" + version;
                                                });
                                                return false;
                                            }
                                            if (isUCP()) {
                                                location.href = "/public_build/views/index.html#page/main?version=" + version;
                                            } else {
                                                location.href = "/public_build/views/preIndex.html#page/main?version=" + version;
                                            }
                                        } else {
                                            $('.errortip').html(data.msg);
                                            $('#loading').fadeOut(1000);
                                            getVerifyCode()
                                        }
                                    },
                                })
                            } else {
                                $('#loading').fadeOut(1000);
                                getVerifyCode()
                            }
                        })
                    } else {
                        $('.errortip').html(data.msg);
                        $('#loading').fadeOut(1000);
                        getVerifyCode()
                    }
                }
            },
            error: function (xhr, status, statusText) {
                $('.errortip').html('服务器响应错误');
                $('#loading').fadeOut(1000);
                getVerifyCode()
            }
        });
    }
    //记住用户名、密码
    function remember() {
        if ($('#expires').is(':checked')) {
            $.cookie('userName', $('#vc2Username').val(), {
                expires: 7,
                path: '/'
            });
        } else {
            $.cookie('userName', null);
        }
    }

    //加载用户名
    function initUserName() {
        if ($.cookie('userName') != 'null') {
            $('#vc2Username').val($.cookie('userName'));
        }
    }

    getVerifyCode()

    $("#verifyImg").click(function () {
        getVerifyCode();
    });

    function getVerifyCode() {
        $.ajax({
            url: setDomain("manage", "sso/getVerifyCode.do"),
            async: false,
            dataType: "json",
            success: function (data) {
                $("#verifyImg").attr("src", "data:image/jpg;base64," + data.responseBody.imgBase64);
                $("#verifyUuid").val(data.responseBody.uuid);
            }
        })
    }

    function getQuoteCityCode() {
        $.ajax({
            url: setDomain("order", "enquiry/getQuoteCityCode.do"),
            async: false,
            dataType: "json",
            success: function (data) {
                if (data.code == '10000') {
                    localStorage.setItem('quoteCityCode', JSON.stringify(data.responseBody));
                }
            }
        })
    }

    $("#updatePwd").click(function () {
        $("#newUserName").val('');
        $("#oldPassword").val('');
        $("#newPassword").val('');
        $("#affirmPassword").val('');
        $("#updatePsdProp").show();
    })

    $("#psdClose").click(function () {
        $("#updatePsdProp").hide();
    })

    $("#psdSave").click(function () {
        var params = {
            username: hasValue($("#newUserName").val()) ? $("#newUserName").val().replace(/\s+/g, "") : "",
            userPwd: hasValue($("#oldPassword").val()) ? $("#oldPassword").val().replace(/\s+/g, "") : "",
            newPassword: hasValue($("#newPassword").val()) ? $("#newPassword").val().replace(/\s+/g, "") : ""
        }
        $.ajax({
            url: setDomain("manage", "user/updPwd.do"),
            type: "post",
            data: params,
            dataType: "json",
            success: function (data) {
                if (data.success) {
                    $('#updatePsdProp').hide()
                }
                alert(data.msg);
            }
        });
    })


    $(".password").click(function () {
        if ($(this).parent().find("input").attr("type") == "text") {
            $(this).parent().find("input").attr("type", "password");
            $(this).removeClass("fa-eye-slash").addClass("fa-eye")
        } else {
            $(this).parent().find("input").attr("type", "text");
            $(this).removeClass("fa-eye").addClass("fa-eye-slash")
        }
    })


});
